import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface GstDetails {
  gstin: string;
  valid: boolean;
  error?: string;
  verified: boolean;
  source: 'offline' | 'provider';
  stateCode: string;
  state: string | null;
  pan: string | null;
  entityNumber: string | null;
  holderType: string | null;
  legalName?: string | null;
  tradeName?: string | null;
  status?: string | null;
  registrationDate?: string | null;
  address?: string | null;
}

export const gstApi = {
  lookup: async (gstin: string): Promise<GstDetails> =>
    (await apiClient.get<ApiSuccess<GstDetails>>(`/gst/${encodeURIComponent(gstin)}`)).data.data,

  /** Download a branded PDF summary of the GST details (auth-aware blob download). */
  async downloadSummary(gstin: string): Promise<void> {
    const res = await apiClient.get(`/gst/${encodeURIComponent(gstin)}/summary.pdf`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data as Blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `gst-${gstin}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  },
};
